import React from 'react'
import { formatInBrazilianDate } from 'utils/functions'

import styles from './styles'
import DisplayAnswerItems from './DisplayAnswerItems'

function DisplayFinancialEntityPosition(props) {
  const { questionData } = props
  const classes = styles()

  const buildFinancialEntityPosition = (occupationInfo) => {
    return (
      <div className={classes.answersContainer} key={occupationInfo.key}>
        <p>
          <span>Cargo: </span>
          {occupationInfo?.role}
        </p>
        <p>
          <span>Atividades desempenhadas: </span>
          {occupationInfo?.developed_activities}
        </p>
        <p>
          <span>Reporta/reportava-se a: </span>
          {occupationInfo?.reports_to}
        </p>

        <p>
          <span>Continua exercendo atividade: </span>
          {occupationInfo?.currently_at_this_job ? 'Sim' : 'Não'}
        </p>

        {occupationInfo?.currently_at_this_job && (
          <React.Fragment>
            <p>
              <span>Horários da jornada de tabalho: </span>
              {`${occupationInfo?.start_working_hours} às ${occupationInfo?.end_working_hours}`}
            </p>
            <p>
              <span>Horários da jornada de assessoria: </span>
              {`${occupationInfo?.investment_advisory_start_time} às ${occupationInfo?.investment_advisory_end_time}`}
            </p>
          </React.Fragment>
        )}

        {occupationInfo?.end_of_contract ? (
          <p>
            <span>Fim do vínculo: </span>
            {formatInBrazilianDate(occupationInfo?.end_of_contract)}
          </p>
        ) : null}
      </div>
    )
  }

  return (
    <div className={classes.root}>
      <h3>Detalhamento das ocupações:</h3>
      <DisplayAnswerItems
        answerData={questionData}
        noDataMessage="O assessor informou que não ocupa cargo de consultoria ou representação em entidades financeiras."
        funcBuildItem={buildFinancialEntityPosition}
      />
    </div>
  )
}

export default DisplayFinancialEntityPosition
